export default {"src":"/_next/static/media/account_circle-white.aa47e806.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};